import { useState } from 'react';
import { Card } from 'react-bootstrap';
import PageHeader from 'components/common/PageHeader';
import PromotionsGrid from './components/PromotionsGrid';
import UploadRibbon from './components/UploadRibbon';

export default function BulkPromotionManagement() {
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  function handleRefresh() {
    setRefreshTrigger(prev => prev + 1);
  }

  return (
    <>
      <PageHeader
        title="Bulk Promotion Management"
        description="Manage product discounts and promotions across your catalog"
        className="mb-3"
      />

      {/* Compact Upload Ribbon */}
      <UploadRibbon onComplete={handleRefresh} />

      {/* Promotions Grid */}
      <Card>
        <Card.Header className="bg-light">
          <h5 className="mb-0">Current & Past Promotions</h5>
        </Card.Header>
        <Card.Body>
          <PromotionsGrid key={refreshTrigger} onRefresh={handleRefresh} />
        </Card.Body>
      </Card>
    </>
  );
}
